<template>
  <Layout style="height: 100%"
          class="main">
    <Sider hide-trigger
           collapsible
           :width="256"
           :collapsed-width="64"
           v-model="collapsed"
           class="left-sider"
           :style="{overflow: 'hidden'}">
      <side-menu accordion
                 ref="sideMenu"
                 :active-name="$route.name"
                 :collapsed="collapsed"
                 @on-select="turnToPage"
                 :menu-list="menuList">
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div class="logo-con">
          <!-- <img v-show="!collapsed" :src="maxLogo" key="max-logo" /> -->
          <span v-show="!collapsed"
                style="font-size: 26px; color: #ffffff; margin-left: 14px;">{{ oem && oem.name || `${$config.title}${$t('components_main_main_21')}` }} {{$t('components_main_main_22')}}</span>
          <img v-show="collapsed"
               :src="$config.logo"
               key="min-logo" />
        </div>
      </side-menu>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar :collapsed="collapsed" @on-coll-change="handleCollapsedChange">
          <user :message-unread-count="unreadCount"
                :user-avator="userAvator" />
          <fullscreen v-model="isFullscreen"
                      style="margin-right: 10px;" />

          <span style="margin-right: 10px;">{{this.me.role}}</span>
          <span style="margin-right: 10px;">{{this.me.mobile}}</span>
          <Dropdown ref="dropdown" trigger="click" @on-click="changeLanguage" style="margin-right: 10px;">
            <a href="javascript:void(0)">
                {{languageName}}
                <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu ref="dropdown" slot="list">
              <template v-for="(child) in languages">
                <DropdownItem :key="`drop-${child[0]}`" :name="child[1]">
                  {{ child[0] }}
                </DropdownItem>
              </template>
            </DropdownMenu>
          </Dropdown>
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          <div class="tag-nav-wrapper">
            <tags-nav :value="$route"
                      @input="handleClick"
                      :list="tagNavList"
                      @on-close="handleCloseTag" />
          </div>
          <Content class="content-wrapper">
            <keep-alive :include="cacheList">
              <router-view />
            </keep-alive>
            <ABackTop :height="100"
                      :bottom="80"
                      :right="50"
                      container=".content-wrapper"></ABackTop>
          </Content>
        </Layout>
      </Content>
    </Layout>
  </Layout>
</template>
<script>
import i18n from '../../locales/index'

import SideMenu from './components/side-menu'
import HeaderBar from './components/header-bar'
import TagsNav from './components/tags-nav'
import User from './components/user'
import ABackTop from './components/a-back-top'
import Fullscreen from './components/fullscreen'
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'
import { getNewTagList, routeEqual } from '@/libs/util'
import routers from '@/router/routers'
// import maxLogo from '@/assets/images/logo.jpg'
import './main.less'
export default {
  name: 'Main',
  components: {
    SideMenu,
    HeaderBar,
    TagsNav,
    Fullscreen,
    User,
    ABackTop
  },
  data () {
    return {
      versionName: process.env.VUE_APP_ENV === 'production' ? '' : i18n.t('components_main_main_23'),
      collapsed: false,
      // maxLogo,
      isFullscreen: false,
      languages: [
        // [i18n.t('pages_settings_index_1007'), "zh"],
        // // [i18n.t('pages_settings_index_1008'), "ft"],
        // [i18n.t('pages_settings_index_1009'), "en"],
        // [i18n.t('pages_settings_index_1013'), "es"],
        ["中文简体", "zh"],
        ["中文繁體", "ft"],
        ["English", "en"],
        ["日本語", "jp"],
        ["Español", "es"],
        ["Français", "fr"],
        ["Tiếng Việt", "vi"],
        ["한국어", "kr"],
        ["Italiano", "eu"],
        ["Deutsch", "de"],
        ["ภาษาไทย", "th"]
      ],
      language: localStorage.getItem("language") || i18n.t('components_main_main_1340'),
    }
  },
  computed: {
    ...mapGetters('editor', ['me']),
    ...mapState('oem', ['oem']),
    languageName () {
      const val = this.languages.find(item => item[1] === this.language)

      return val ? val[0] : i18n.t('components_main_main_1340')
    },
    tagNavList () {
      return this.$store.state.tagNavList
    },
    tagRouter () {
      return this.$store.state.tagRouter
    },
    userAvator () {
      return this.me.avator || this.$config.logo
    },
    cacheList () {
      const list = [
        'ParentView',
        ...(this.tagNavList.length
          ? this.tagNavList
            .filter(item => !(item.meta && item.meta.notCache))
            .map(item => item.name)
          : [])
      ]
      return list
    },
    menuList () {
      return this.$store.getters.menuList
    },
    local () {
      return this.$store.state.local
    },
    hasReadErrorPage () {
      return this.$store.state.hasReadErrorPage
    },
    unreadCount () {
      return this.$store.state.editor.unreadCount
    }
  },
  methods: {
    ...mapActions('editor', [
      'logout',
      'change_pwd',
      'getUnreadMessageCount'
    ]),
    ...mapMutations([
      'setBreadCrumb',
      'setTagNavList',
      'addTag',
      'setHomeRoute',
      'closeTag'
    ]),
    changeLanguage(val) {
      i18n.locale = val
      console.log("i18n.locale", i18n.locale)
      this.language = this.languages.find(item => item[1] === val)[1]
      localStorage.setItem("language", this.language)
      location.reload()
    },
    turnToPage (route) {
      let { name, params, query } = {}
      if (typeof route === 'string') name = route
      else {
        name = route.name
        params = route.params
        query = route.query
      }
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1])
        return
      }
      this.$router.push({
        name,
        params,
        query
      })
    },
    handleCollapsedChange (state) {
      this.collapsed = state
    },
    handleCloseTag (res, type, route) {
      if (type !== 'others') {
        if (type === 'all') {
          this.turnToPage(this.$config.homeName)
        } else {
          if (routeEqual(this.$route, route)) {
            this.closeTag(route)
          }
        }
      }
      this.setTagNavList(res)
    },
    handleClick (item) {
      this.turnToPage(item)
    }
  },
  watch: {
    $route (newRoute) {
      const { name, query, params, meta } = newRoute
      this.addTag({
        route: { name, query, params, meta },
        type: 'push'
      })
      this.setBreadCrumb(newRoute)
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute))
      this.$refs.sideMenu.updateOpenName(newRoute.name)
    }
  },
  mounted () {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList()
    this.setHomeRoute(routers)
    const { name, params, query, meta } = this.$route
    this.addTag({
      route: { name, params, query, meta }
    })
    this.setBreadCrumb(this.$route)
    // 如果当前打开页面不在标签栏中，跳到homeName页
    if (!this.tagNavList.find(item => item.name === this.$route.name)) {
      this.$router.push({
        name: this.$config.homeName
      })
    }
    // 获取未读消息条数
    this.getUnreadMessageCount()
  }
}
</script>
